import {createRouter, createWebHistory, RouteRecordRaw} from "vue-router";
import LoginView from "@/pages/LoginPage/LoginPage.vue";
import ForgotPasswordPage from "@/pages/Settings/ForgotPasswordPage.vue";
import DashboardPage from "@/pages/DashboardPage/DashboardPage.vue";
import UserTablePage from "@/pages/Users/UserTablePage/UserTablePage.vue";
import UserDetailPage from "@/pages/Users/UserDetailPage/UserDetailPage.vue";
import TenantTablePage from "@/pages/Manage/TenantTablePage/TenantTablePage.vue";
import CouponTablePage from "@/pages/Manage/CouponTablePage/CouponTablePage.vue";
import AccessCodeTablePage from "@/pages/Licenses/AccessCodeTablePage/AccessCodeTablePage.vue";
import AccessCodeDetailPage from "@/pages/Licenses/AccessCodeDetailPage/AccessCodeDetailPage.vue";
import CouponDetailPage from "@/pages/Manage/CouponDetailPage/CouponDetailPage.vue";
import TenantDetailPage from "@/pages/Manage/TenantDetailPage/TenantDetailPage.vue";
import {useGlobalStore} from "@/store";
import yapi from "@/lib/yapi";
import InstitutionTablePage from "@/pages/Manage/InstitutionTablePage.vue";
import InstitutionDetailPage from "@/pages/Manage/InstitutionDetailPage/InstitutionDetailPage.vue";
import CohortDetailPage from "@/pages/Manage/CohortDetailPage/CohortDetailPage.vue";
import ReportsPage from "@/pages/Insights/ReportsPage/ReportsPage.vue";
import CohortTablePage from "@/pages/Manage/CohortTablePage.vue";
import UserSettingsPage from "@/pages/Settings/UserSettingsPage/UserSettingsPage.vue";
import ProfilePage from "@/pages/Settings/UserSettingsPage/ProfilePage.vue";
import PasswordPage from "@/pages/Settings/UserSettingsPage/PasswordPage.vue";
import AppearancePage from "@/pages/Settings/UserSettingsPage/AppearancePage.vue";
import AppConfigurationPage from "@/pages/Settings/AppConfigurationPage/AppConfigurationPage.vue";
import GeneralConfigForm from "@/pages/Settings/AppConfigurationPage/components/GeneralConfigForm.vue";
import OnboardingConfigSection from "@/pages/Settings/AppConfigurationPage/components/OnboardingConfigSection.vue";
import AuthMethodsConfigForm from "@/pages/Settings/AppConfigurationPage/components/AuthMethodsConfigForm.vue";
import LocalisationConfigForm from "@/pages/Settings/AppConfigurationPage/components/LocalisationConfigForm.vue";
import FeatureConfigForm from "@/pages/Settings/AppConfigurationPage/components/FeatureConfigSection.vue";
import IntegrationsConfigForm from "@/pages/Settings/AppConfigurationPage/components/IntegrationsConfigForm.vue";
import ThemeConfigSection from "@/pages/Settings/AppConfigurationPage/components/ThemeConfigSection.vue";
import ValueScalesCompletionReport
  from "@/pages/Insights/ReportsDetailPage/Reports/UsageReports/ValueScalesCompletionReport.vue";
import AccessCodeUsageReport from "@/pages/Insights/ReportsDetailPage/Reports/UsageReports/AccessCodeUsageReport.vue";
import HollandCodeCompletionReport
  from "@/pages/Insights/ReportsDetailPage/Reports/UsageReports/HollandCodeCompletionReport.vue";
import Big5CompletionReport from "@/pages/Insights/ReportsDetailPage/Reports/UsageReports/Big5CompletionReport.vue";
import LearningStylesCompletionReport
  from "@/pages/Insights/ReportsDetailPage/Reports/UsageReports/LearningStylesCompletionReport.vue";
import RockPaperScissorsCompletionReport
  from "@/pages/Insights/ReportsDetailPage/Reports/UsageReports/RockPaperScissorsCompletionReport.vue";
import MazeCompletionReport from "@/pages/Insights/ReportsDetailPage/Reports/UsageReports/MazeCompletionReport.vue";
import PerceivingEmotionsCompletionReport
  from "@/pages/Insights/ReportsDetailPage/Reports/UsageReports/PerceivingEmotionsCompletionReport.vue";
import ManagingEmotionsCompletionReport
  from "@/pages/Insights/ReportsDetailPage/Reports/UsageReports/ManagingEmotionsCompletionReport.vue";
import UnderstandingEmotionsCompletionReport
  from "@/pages/Insights/ReportsDetailPage/Reports/UsageReports/UnderstandingEmotionsCompletionReport.vue";
import UserWorkerTypeResultsReport
  from "@/pages/Insights/ReportsDetailPage/Reports/UserResultReports/UserWorkerTypeResultsReport.vue";
import UserPersonalityTraitsResultsReport
  from "@/pages/Insights/ReportsDetailPage/Reports/UserResultReports/UserPersonalityTraitsResultsReport.vue";
import UserLearningStylesResultsReport
  from "@/pages/Insights/ReportsDetailPage/Reports/UserResultReports/UserLearningStylesResultsReport.vue";
import UserValueScalesResultsReport
  from "@/pages/Insights/ReportsDetailPage/Reports/UserResultReports/UserValueScalesResultsReport.vue";
import SubjectChoiceCompletionReport
  from "@/pages/Insights/ReportsDetailPage/Reports/UsageReports/SubjectChoiceCompletionReport.vue";
import UserSubjectChoicesResultsReport
  from "@/pages/Insights/ReportsDetailPage/Reports/UserResultReports/UserSubjectChoicesResultsReport.vue";
import HollandCodeDistributionReport
  from "@/pages/Insights/ReportsDetailPage/Reports/DistributionReports/HollandCodeDistributionReport.vue";
import PersonalityTraitsDistributionReport
  from "@/pages/Insights/ReportsDetailPage/Reports/DistributionReports/PersonalityTraitsDistributionReport.vue";
import SubjectChoiceDistributionReport
  from "@/pages/Insights/ReportsDetailPage/Reports/DistributionReports/SubjectChoiceDistributionReport.vue";
import SchoolDashboardPage from "@/pages/MySchool/SchoolDashboardPage/SchoolDashboardPage.vue";
import InstitutionDashboard from "@/pages/MySchool/InstitutionDashboard/InstitutionDashboard.vue";
import CohortDashboard from "@/pages/MySchool/CohortDashboard/CohortDashboard.vue";
import InstitutionAccessCodeDetailPage from "@/pages/MySchool/InstitutionDashboard/InstitutionAccessCodeDetailPage.vue";
import CohortAccessCodeDetailPage from "@/pages/MySchool/CohortDashboard/CohortAccessCodeDetailPage.vue";
import TenantAccessCodeDetailPage from "@/pages/MySchool/SchoolDashboardPage/TenantAccessCodeDetailPage.vue";
import TenantUserDetailPage from "@/pages/MySchool/SchoolDashboardPage/TenantUserDetailPage.vue";
import InstitutionUserDetailPage from "@/pages/MySchool/InstitutionDashboard/InstitutionUserDetailPage.vue";
import CohortUserDetailPage from "@/pages/MySchool/CohortDashboard/CohortUserDetailPage.vue";
import SchoolDashboardWithoutTenantPage
  from "@/pages/MySchool/SchoolDashboardWithoutTenant/SchoolDashboardWithoutTenantPage.vue";
import {Role} from "@YenzaCT/sdk";
import GroupAnalysisReport from "@/pages/Insights/ReportsDetailPage/Reports/GroupAnalysisReport.vue";

const routes: RouteRecordRaw[] = [
  {
    path: "/login",
    name: "login",
    component: LoginView
  },
  {
    path: "/forgot-password/request",
    name: "forgotPassword",
    component: ForgotPasswordPage
  },
  {
    path: "/",
    name: "dashboard",
    component: DashboardPage,
    beforeEnter: async (to, from, next) => {
      const store = useGlobalStore();
      await store.fetchUser();

      if (store.user?.app.role === Role.Manager) {
        next({"name": "schoolsDashboard"});
      } else {
        next();
      }
    }

  },
  {
    path: "/configuration",
    name: "configuration",
    redirect: "/configuration/general",
    component: AppConfigurationPage,
    children: [
      {
        name: "generalConfiguration",
        path: "general",
        component: GeneralConfigForm
      },
      {
        name: "onboardingConfiguration",
        path: "onboarding",
        component: OnboardingConfigSection
      },
      {
        name: "authenticationConfiguration",
        path: "authentication",
        component: AuthMethodsConfigForm
      },
      {
        name: "localisationConfiguration",
        path: "localisation",
        component: LocalisationConfigForm
      },
      {
        name: "featureConfiguration",
        path: "features",
        component: FeatureConfigForm
      },
      {
        name: "themeConfiguration",
        path: "theme",
        component: ThemeConfigSection
      },
      {
        name: "integrationConfiguration",
        path: "integrations",
        component: IntegrationsConfigForm
      }
    ]
  },
  {
    path: "/user-settings",
    name: "userSettings",
    component: UserSettingsPage,
    redirect: "/user-settings/profile",
    children: [
      {
        name: "userSettingsProfile",
        path: "profile",
        component: ProfilePage
      },
      {
        name: "userSettingsPassword",
        path: "password",
        component: PasswordPage
      },
      {
        name: "userSettingsAppearance",
        path: "appearance",
        component: AppearancePage
      }
    ]
  },
  {
    path: "/users",
    name: "users",
    component: UserTablePage
  },
  {
    path: "/users-detail/:userId/:tab?/:reportType?",
    name: "userDetail",
    component: UserDetailPage
  },
  {
    path: "/tenants",
    name: "tenants",
    component: TenantTablePage
  },
  {
    path: "/tenants/:id",
    name: "tenantDetail",
    component: TenantDetailPage
  },
  {
    path: "/institutions",
    name: "institutions",
    component: InstitutionTablePage
  },
  {
    path: "/institutions/:institutionId/:section?",
    name: "institutionDetail",
    component: InstitutionDetailPage
  },
  {
    path: "/cohorts",
    name: "cohorts",
    component: CohortTablePage
  },
  {
    path: "/cohorts/:cohortId",
    name: "cohortDetail",
    component: CohortDetailPage
  },
  {
    path: "/coupons",
    name: "coupons",
    component: CouponTablePage
  },
  {
    path: "/coupons/:id",
    name: "couponDetail",
    component: CouponDetailPage
  },
  {
    path: "/access-code",
    name: "vouchers",
    component: AccessCodeTablePage
  },
  {
    path: "/access-code/:id",
    name: "accessCode",
    component: AccessCodeDetailPage
  },
  {
    path: "/insights",
    name: "reports",
    component: ReportsPage
  },
  {
    path: "/insights/group-dashboard",
    name: "groupAnalysisReport",
    component: GroupAnalysisReport
  },
  {
    path: "/insights/voucher-usage",
    name: "voucherUsageReport",
    component: AccessCodeUsageReport
  },
  {
    path: "/insights/worker-type-completion",
    name: "workerTypeCompletionReport",
    component: HollandCodeCompletionReport
  },
  {
    path: "/insights/personality-type-completion",
    name: "personalityTraitsCompletionReport",
    component: Big5CompletionReport
  },
  {
    path: "/insights/value-scales-completion",
    name: "valueScalesCompletionReport",
    component: ValueScalesCompletionReport
  },
  {
    path: "/insights/subject-choice-completion",
    name: "subjectChoiceCompletionReport",
    component: SubjectChoiceCompletionReport
  },
  {
    path: "/insights/learning-styles-completion",
    name: "learningStylesCompletionReport",
    component: LearningStylesCompletionReport
  },
  {
    path: "/insights/rock-paper-scissors-completion",
    name: "rockPaperScissorsCompletionReport",
    component: RockPaperScissorsCompletionReport
  },
  {
    path: "/insights/maze-completion",
    name: "mazeCompletionReport",
    component: MazeCompletionReport
  },
  {
    path: "/insights/perceiving-emotions-completion",
    name: "perceivingEmotionsCompletionReport",
    component: PerceivingEmotionsCompletionReport
  },
  {
    path: "/insights/managing-emotions-completion",
    name: "managingEmotionsCompletionReport",
    component: ManagingEmotionsCompletionReport
  },
  {
    path: "/insights/understanding-emotions-completion",
    name: "understandingEmotionsCompletionReport",
    component: UnderstandingEmotionsCompletionReport
  },
  {
    path: "/insights/user-worker-type-results",
    name: "userWorkerTypeResultsReport",
    component: UserWorkerTypeResultsReport
  },
  {
    path: "/insights/user-personality-trait-results",
    name: "userPersonalityTraitResultsReport",
    component: UserPersonalityTraitsResultsReport
  },
  {
    path: "/insights/user-learning-styles-results",
    name: "userLearningStylesResultsReport",
    component: UserLearningStylesResultsReport
  },
  {
    path: "/insights/user-value-scales-results",
    name: "userValueScalesResultsReport",
    component: UserValueScalesResultsReport
  },
  {
    path: "/insights/user-subject-choices",
    name: "userSubjectChoices",
    component: UserSubjectChoicesResultsReport
  },
  {
    path: "/insights/worker-type-distribution",
    name: "workerTypeDistributionReport",
    component: HollandCodeDistributionReport
  },
  {
    path: "/insights/personality-traits-distribution",
    name: "personalityTraitsDistributionReport",
    component: PersonalityTraitsDistributionReport
  },
  {
    path: "/insights/subject-choice-distribution",
    name: "subjectChoiceDistributionReport",
    component: SubjectChoiceDistributionReport
  },

  {
    path: "/schools",
    name: "schoolsDashboard",
    component: SchoolDashboardPage,
    beforeEnter: async (to, from, next) => {
      // Redirect to schools with default tenant
      const store = useGlobalStore();
      await store.fetchUser();
      let tenantId: string | undefined;

      if (store.isAdminOrRoot) {
        const res = await yapi.admin.tenant.paginate({size: 1});
        if (res.data.docs.length > 0) {
          tenantId = res.data.docs[0]._id;
        }
      } else if (store.accessibleTenants.length > 0) {
        // Use first accessible tenant for managers
        tenantId = store.accessibleTenants[0];
      }

      if (tenantId) {
        next({name: "schoolsDashboardWithTenant", params: {tenantId}});
      } else {
        next({name: "schoolsDashboardWithoutTenant"});
      }
    }
  },

  {
    path: "/schools/all/:tab?",
    name: "schoolsDashboardWithoutTenant",
    component: SchoolDashboardWithoutTenantPage,
    props: (route) => ({
      tenantId: route.params.tenantId,
      tab: route.params.tab || "dashboard"
    })
  },
  {
    path: "/schools/:tenantId/:tab?",
    name: "schoolsDashboardWithTenant",
    component: SchoolDashboardPage,
    props: (route) => ({
      tenantId: route.params.tenantId,
      tab: route.params.tab || "dashboard"
    })
  },

  {
    path: "/schools/:tenantId/licenses/:id",
    name: "tenantAccessCode",
    component: TenantAccessCodeDetailPage,
    props: (route) => ({
      tenantId: route.params.tenantId,
      accessCodeId: route.params.id
    })
  },

  {
    path: "/schools/:tenantId/institutions/:institutionId/:tab?",
    name: "institutionDashboard",
    component: InstitutionDashboard,
    props: (route) => ({
      tenantId: route.params.tenantId,
      id: route.params.institutionId,
      tab: route.params.tab || "dashboard"
    })
  },

  {
    path: "/schools/:tenantId/institutions/:institutionId/cohorts/:cohortId/:tab?",
    name: "cohortDashboard",
    component: CohortDashboard,
    props: (route) => ({
      tenantId: route.params.tenantId,
      institutionId: route.params.institutionId,
      cohortId: route.params.cohortId,
      tab: route.params.tab || "dashboard"
    })
  },

  {
    path: "/schools/:tenantId/institutions/:institutionId/licenses/:id",
    name: "institutionAccessCode",
    component: InstitutionAccessCodeDetailPage,
    props: (route) => ({
      tenantId: route.params.tenantId,
      institutionId: route.params.institutionId,
      accessCodeId: route.params.id
    })
  },

  {
    path: "/schools/:tenantId/institutions/:institutionId/cohorts/:cohortId/licenses/:id",
    name: "cohortAccessCode",
    component: CohortAccessCodeDetailPage,
    props: (route) => ({
      tenantId: route.params.tenantId,
      institutionId: route.params.institutionId,
      cohortId: route.params.cohortId,
      accessCodeId: route.params.id
    })
  },

  // User detail pages for different contexts
  {
    path: "/schools/:tenantId/users/:userId/:tab?",
    name: "tenantUserDetail",
    component: TenantUserDetailPage,
    props: (route) => ({
      tenantId: route.params.tenantId,
      userId: route.params.userId,
      tab: route.params.tab || "overview"
    })
  },

  {
    path: "/schools/:tenantId/institutions/:institutionId/users/:userId/:tab?",
    name: "institutionUserDetail",
    component: InstitutionUserDetailPage,
    props: (route) => ({
      tenantId: route.params.tenantId,
      institutionId: route.params.institutionId,
      userId: route.params.userId,
      tab: route.params.tab || "overview"
    })
  },

  {
    path: "/schools/:tenantId/institutions/:institutionId/cohorts/:cohortId/users/:userId/:tab?",
    name: "cohortUserDetail",
    component: CohortUserDetailPage,
    props: (route) => ({
      tenantId: route.params.tenantId,
      institutionId: route.params.institutionId,
      cohortId: route.params.cohortId,
      userId: route.params.userId,
      tab: route.params.tab || "overview"
    })
  }

];

const router = createRouter({
  history: createWebHistory("/"),
  routes,
});

router.beforeEach((to, from, next) => {
  const store = useGlobalStore();
  if (to.name === "login" && store.user !== null) next({name: "dashboard"});
  else next();
});

export default router;
